module.exports = __webpack_public_path__ + "e4ffe76f62853658c9a37dc92edfdd31.png";